var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert-config" },
    [
      _vm._m(0),
      _c(
        "el-tabs",
        {
          key: _vm.tabsKey,
          ref: "tabs",
          staticClass: "alarm-configuration",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: { name: "recipients" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "cfg-tab" }, [
                        _c("div", [
                          _vm._v("告警接收人 / Destinatários de Alerta"),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("recipient-pane")],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { name: "templates" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "cfg-tab" }, [
                        _c("div", [_vm._v("告警文案 / Modelos de Alerta")]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("template-pane")],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { name: "states" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "cfg-tab" }, [
                        _c("div", [_vm._v("监控州配置 / Escopo de Estados")]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("monitor-state-pane")],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { name: "configLog" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "cfg-tab" }, [
                        _c("div", [_vm._v("配置变更日志 / Log de Alterações")]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("config-log-pane")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "ph-left" }, [
        _c("h2", { staticStyle: { "margin-top": "0" } }, [
          _c("span", [_vm._v("告警配置")]),
          _c("span", { staticClass: "h2-pt" }, [
            _vm._v("Configuração de Alertas"),
          ]),
        ]),
        _c("div", { staticClass: "desc" }, [
          _c("span", [
            _vm._v(
              "配置飞书群组接收人、推送文案、纳入监控的州范围，并留痕配置变更"
            ),
          ]),
          _c("span", { staticClass: "desc-pt" }, [
            _vm._v(
              "Configure destinatários de grupos Feishu, textos de alerta e o escopo de estados monitorados, com registro das alterações"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }